<template lang="pug">
  div.garbage.defense-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="onSubmitModalForm()"
    :hideDeleteButton="false"
    :saveBtnLabel="locationTariffIsActive ? 'Рассчитать' : 'Сохранить'"
    :savingBtnLabel="locationTariffIsActive ? 'Расcчет...' : 'Сохранение...'"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="type_id"
                  label="Тип"
                  inputType="select"
                  :options="geoObjectTypes"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                template(
                  v-if="parentItem && parentItems"
                )
                  e-form-group(
                    v-if="parentItemsList.length > 0"
                    name="parent_id"
                    label="Находится в составе"
                    :model="fields"
                    tabView="tab1"
                    inputType="select"
                    :options="parentItemsList"
                  )
                e-form-group(
                name="okato"
                inputType="input"
                validationRule="number"
                label="ОКАТО"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="oktmo"
                inputType="input"
                validationRule="number"
                label="OKTMO"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="area"
                inputType="input"
                validationRule="double"
                label="Площадь, га"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                :model="fields"
                inputType="checkbox"
                caption="Бесконтейнерный сбор"
                tabView="tab1"
                name="is_msn"
                title="Объект административно-территориального деления будет добавлен(удален) в(из) реестр(а) бесконтейнерного сбора"
                )
                e-form-group(
                name="tko_operator_id"
                inputType="select"
                label="Региональный оператор"
                optionValueKey="id"
                optionTextKey="name"
                :required="true"
                :model="fields"
                :options="regionalOperators"
                placeholder="Укажите оператора"
                tabView="tab1"
                )

              div.col
                e-form-subtitle(text="Численность населения, чел.")

                e-form-group(
                name="year"
                inputType="select"
                :options="years"
                label="Год"
                :model="currentResidentYear"
                @change="setCurrentResidents()"
                tabView="tab1"
                )
                e-form-group(
                name="apartment_building_residence"
                inputType="input"
                label="Численность в МКД, чел"
                :model="currentResidents"
                tabView="tab1"
                validationRule="number"
                :onChangeValidation="true"
                )
                e-form-group(
                name="private_house_residence"
                inputType="input"
                label="Численность в ИЖД, чел"
                :model="currentResidents"
                tabView="tab1"
                validationRule="number"
                :onChangeValidation="true"
                )
                e-form-group(
                  name="total_residents"
                  inputType="input"
                  label="Итого:"
                  :model="currentResidents"
                  tabView="tab1"
                )

              div.col
                div.col-block

                e-form-group(
                  name="detail"
                  inputType="textarea"
                  label="Контактные данные"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="link"
                  inputType="url"
                  label="Сайт"
                  :model="fields"
                  tabView="tab1"
                )


          // вкладка НАСЕЛЕННЫЕ ПУНКТЫ
          div(v-show="tabView == 'tab2'")
            ierarchy-locations-table(
              :fields="fields"
            )

          div(v-show="tabView == 'garbage'")
            garbage-threads-table(
             :id="fields.id"
            )

          div(v-show="tabView == 'location-tariff'")
            location-tariff(
              v-if="locationTariffIsShowed"
              :model="fields"
            )

</template>

<script>
  import {atu, core, tko, calculation} from '../../../api/api-endpoints.js'
  import objectForm from '../mixins/object-form.js'
  import GarbageThreadsTable from "../components/garbage-threads-table";

  import LocationTariff from "../components/location-tariff";
  import IerarchyLocationsTable from "../components/ierarchy-locations-table";
  import FormValidator from '../../../components/form/form-validator'


  const locationTariff = 'location-tariff';

  export default {
    components: {IerarchyLocationsTable, GarbageThreadsTable, LocationTariff},
    mixins: [objectForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          _garbageYear: ''
        },
        errors: null
      }
    },
    computed: {
      locationTariffIsShowed () {
        return !this.fields.parent_id
      },
      locationTariffIsActive () {
        return this.tabView === locationTariff
      },
      tabs () {
        const tabs = [
          {tab1: 'Общие сведения'}
        ];

        if (this.fields.id) {
          tabs.push({tab2: 'Населенные пункты'})
        }

        if (this.fields.id && this.locationTariffIsShowed) {
          tabs.push({[locationTariff]: 'Расчет тарифа'})
        }

        if (this.fields.id) {
          tabs.push({garbage: 'Отходы'})
        }

        return tabs
      }
    },
    created () {
      this.formValidator = new FormValidator(this);
      this.subs = this.$emitter.listen('calc', this.calc);
      this.fetchTariff()
    },
    destroyed () {
      this.subs && this.subs.unsubscribe()
    },
    methods: {
      async fetchTariff () {
        try {
          this.$bar.start();

          if (this.fields.tariff_id) {
            const {data} = await this.$store.dispatch('updateUrlEndpoint', {
              endpoint: calculation.locationTariffOneAtu(this.fields.tariff_id),
              params: {
                disableGlobalError: true
              }
            });

            this.mapTariffToFields(data)
          }
        } catch (e) {
          console.error(e);
          this.$e.errorBox('Ошибка при загрузке тарифа')
        } finally {
          this.$bar.finish()
        }
      },
      getRegionalOperatorEndpoint () {
        return tko.regionalOperators({query: {'per-page': -1}})
      },
      getUpdateOrCreateUrl () {
        return atu.atuObjectUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return atu.atuObject(route.params.id)
      },
      getCollectionEndpoint () {
        return core.collection('geo_object_type')
      },
      getEndpoint (route) {
        return atu.atuObjects(route)
      },
      onSubmitModalForm () {
        if (this.locationTariffIsActive) {
          this.freezeForm();
          this.$emitter.emit('calc', {
            unFreezeFrom: () => this.unFreezeFrom()
          })
        } else {
          this.sendForm()
        }
      },
      async calc ({unFreezeFrom = () => ''} = {}) {
        let {hasError} = this.formValidator.validate(this);
        if(hasError){
          this.$e.errorBox('Проверьте все обязательные поля!');
          unFreezeFrom();
          return
        }
        try {
          if(!this.fields.tariff_id){
            let {data} = await this.$store.dispatch('createModel', {
              url: calculation.locationTariff(),
              data: this.fields
            });
            this.fields.tariff_id = data.id
          }
          let {data} = await this.$store.dispatch('updateModel', {
            url: calculation.locationTariffOneAtuUpdate(this.fields.tariff_id),
            data: this.fields
          });
          this.mapTariffToFields(data);

          this.$e.successBox('Рассчет завершен');
          this.$emit('calcSuccess')

        } catch (erResponse) {
          let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this);
          if (notFoundedErrorFieldsText) {
            this.$e.errorBox(
              'Некорректно заполнены поля',
              {text: notFoundedErrorFieldsText}
            )
          }
        }
        unFreezeFrom()
      },
    }
  }
</script>
